import TemplateView from '../../../../../js/TemplateView'
import SimpleListMenuButton from '../../../../../js/SimpleListMenuButton'
import messageResource from '../../../../../js/messageResource'
import {DEFAULT_SORTING, SortingProperty} from '../../constants'

export default class FeedsTableSortingMenu extends TemplateView {

    constructor({
        changeSorting,
        isLastSyncSortingIncluded = false,
    }) {
        super()

        this.params = {
            isLastSyncSortingIncluded,
        }

        this.state = {
            sorting: DEFAULT_SORTING,
        }

        this.callbacks = {
            changeSorting
        }

        this.onStatePropertyDeeplyChanged('sorting', sorting => {
            this.sortingListMenuSelector.setActiveItemByPredicate(item => item.value === sorting.property)
            this.$sortingOrderButton.toggleClass('descOrder', !sorting.isAsc)
        })
    }

    templateHtml() {
        return `<div class='feedsSort'>
                    <div class='sortedByText'>
                        <%=sortedBy%>
                    </div>
                    <div class='listSelector'/>
                    <div class='sortingOrderButton'/>
                </div>`
    }

    messageKeys() {
        return {
            sortedBy: 'icalendar.page.table.sorting.sorted_by'
        }
    }

    afterRender() {
        const sortingItems = [
            {
                title: messageResource.getMessage('icalendar.page.table.sorting.feed'),
                value: SortingProperty.FEED_NAME,
            },
            {
                title: messageResource.getMessage('icalendar.page.table.sorting.creator'),
                value: SortingProperty.CREATOR_NAME,
            },
            {
                title: messageResource.getMessage('icalendar.page.table.sorting.editor'),
                value: SortingProperty.EDITOR_NAME,
            },
            {
                title: messageResource.getMessage('icalendar.page.table.sorting.date.created'),
                value: SortingProperty.CREATED_DATE,
            },
            {
                title: messageResource.getMessage('icalendar.page.table.sorting.date.edited'),
                value: SortingProperty.EDITED_DATE,
            }
        ]

        if (this.params.isLastSyncSortingIncluded) {
            sortingItems.push({
                title: messageResource.getMessage('icalendar.page.table.columns.sync'),
                value: SortingProperty.LAST_SYNC,
            })
        }

        this.sortingListMenuSelector = new SimpleListMenuButton({
            itemHeight: 33,
            emptySelectionMessageKey: 'icalendar.page.table.sorting.feed',
            itemHtmlCallback: sortingItem => sortingItem.title,
            onSelect: sortingItem => this.callbacks.changeSorting({
                property: sortingItem.value,
                isAsc: this.state.sorting.isAsc,
            }),
            autoMenuWidth: false,
        }).init(this.find('.listSelector'))
        this.sortingListMenuSelector.setItems(sortingItems)

        this.$sortingOrderButton = this.find('.sortingOrderButton')
        this.$sortingOrderButton.on('click', () =>
            this.callbacks.changeSorting({
                property: this.state.sorting.property,
                isAsc: !this.state.sorting.isAsc
            })
        )
        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/FeedsTableSortingMenu.js